module.exports = __webpack_public_path__ + "img/2f_r_koichiro.1be277d8.jpg";